import type { ComponentType, SVGProps } from 'react';
import { CameraIcon, ClipboardDocumentListIcon, UserIcon } from '@heroicons/react/24/outline';
import type { SubmissionStepId } from './submissionProgress';

export interface SubmissionStepMeta {
    id: SubmissionStepId;
    label: string;
    icon: ComponentType<SVGProps<SVGSVGElement>>;
}

export const SUBMISSION_STEPS: readonly SubmissionStepMeta[] = [
    { id: 'patient', label: 'Patient details', icon: UserIcon },
    { id: 'treatment', label: 'Treatment', icon: ClipboardDocumentListIcon },
    { id: 'photos', label: 'Photos', icon: CameraIcon }
];
